import { Controller } from "stimulus"

// Checkout passenger row: CNIC is required unless the passenger is marked as a child.
export default class extends Controller {
  static targets = ["child", "cnic"]

  connect() {
    this.toggle()
  }

  toggle() {
    const child = this.childTarget.checked
    this.cnicTarget.required = !child
    this.cnicTarget.placeholder = child ? 'CNIC (optional for a child)' : 'CNIC'
  }
}
